import {useQuery} from '@tanstack/react-query';
import {API} from '@chekin/api';
import {QUERY_CACHE_KEYS,LockConditions} from '@chekin/core';
import {useReservation} from 'context/reservation';

type UseFetchLockConditionsProps = {
  enabled?: boolean;
};

function useFetchLockConditions({enabled = true}: UseFetchLockConditionsProps = {}) {
  const {data: reservation} = useReservation();
  const enabledFetching = Boolean(!!reservation?.id && enabled);

  return useQuery<LockConditions, Error>({
    queryKey: [QUERY_CACHE_KEYS.lockConditions, reservation?.id],
    queryFn: () => API.locks.getLockConditions(`reservation_id=${reservation?.id}`),
    enabled: enabledFetching,
    refetchOnWindowFocus: false,
    staleTime: 3000,
  });
}

export {useFetchLockConditions};
